import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";

export default function PageSeven() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >   
            <div className="centered main heightCenter">
                <div className="featureCard flexible">
                    <h2><FormattedMessage id="dataSecShort" /></h2>
                    <ul>
                        <li><FormattedMessage id="dataSec1" /></li>
                        <li><FormattedMessage id="dataSec2" /></li>
                        <li><FormattedMessage id="dataSec3" /></li>
                        <li><FormattedMessage id="dataSec4" /></li>
                        <li><FormattedMessage id="dataSec5" /></li>
                        <li><FormattedMessage id="dataSec6" /></li>
                    </ul>
                    <a href="privacy" className="centered"><FormattedMessage id="dataSecLong" /></a>
                </div>
            </div>
        </motion.div>
    );
}